"use client";

import ImageAtom from "@components/atoms/Image";
import styles from "./NotAvailableContainer.module.scss";
import assetLoader from "@utils/internalImageLoder";
import { use, useEffect } from "react";
import { trackSystemError } from "@utils/exceptionTracker";
import Button from "@components/atoms/Button";

interface NotAvailableContainerProps {
  type: string;
  slug?: string;
  error: string;
  className?: string;
  pageType: string;
}

export default function NotAvailableContainer({
  type,
  slug,
  error,
  pageType,
  className,
}: NotAvailableContainerProps) {
  useEffect(() => {
    trackSystemError("page_unavailable", pageType, {
      type,
      slug,
    });
  }, [error]);

  return (
    <div className={`${styles.container} ${className || ""}`}>
      <div className={styles.iconContainer}>
        <ImageAtom
          src={`${assetLoader()}/images/nocontent.svg`}
          alt="not-available"
          width={361}
          height={181}
        />
      </div>

      <h1 className={styles.title}>Content Not Available</h1>

      <p className={styles.description}>{error}</p>

      <div className={styles.actions}>
        <Button
          className={styles.secondaryButton}
          onClick={() => (window.location.href = "/cars")}
        >
          Browse Cars
        </Button>
      </div>
    </div>
  );
}
